import { useEffect, useState } from 'react';
import Skeleton from '@mui/material/Skeleton';
import enarmApexExamenes from 'assets/img/simuladorExamenes.png';

// components

export default function CardCustomTest({ onClick, loading = false }) {
  const [imageSize, setImageSize] = useState(64);

  useEffect(() => {
    const updateImageSize = () => {
      const width = window.innerWidth;
      const isTablet = width >= 768 && width < 1024;
      setImageSize(width < 768 ? 64 : isTablet ? 88 : 120);
    };

    updateImageSize();
    window.addEventListener('resize', updateImageSize);

    return () => {
      window.removeEventListener('resize', updateImageSize);
    };
  }, []);

  const showSkeleton = loading;

  if (showSkeleton) {
    return (
      <div className="dashboard-feature-card relative w-full mb-6 rounded-2xl border border-indigo-100 bg-white p-4 shadow-sm">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div className="min-w-0 space-y-2 md:flex-1">
            <Skeleton variant="text" width="70%" height={42} animation="wave" />
            <Skeleton variant="text" width="45%" height={22} animation="wave" />
          </div>
          <Skeleton variant="circular" width={imageSize} height={imageSize} animation="wave" />
        </div>
        <Skeleton variant="rounded" width="100%" height={52} animation="wave" sx={{ mt: 2 }} />
      </div>
    );
  }

  return (
    <div className="dashboard-feature-card relative mb-3 flex w-full items-center rounded-2xl border border-indigo-100 bg-white p-3 shadow-sm md:mb-6 md:block md:p-4">
      <div className="flex min-w-0 flex-1 items-center gap-2 md:gap-4 md:justify-between">
        <div className="min-w-0 flex-1 space-y-1 text-left text-indigo-950 md:self-stretch md:flex md:flex-col md:justify-center md:space-y-2">
          <h4 className="text-lg font-bold leading-tight md:text-2xl">Simulador ENARM</h4>
          <p className="hidden text-sm font-semibold text-indigo-700 md:block">Examen completo</p>
        </div>
        <div
          className="flex shrink-0 items-center justify-center md:mx-0"
          style={{ width: `${imageSize}px`, height: `${imageSize}px` }}
        >
          <img
            src={enarmApexExamenes}
            alt="Ilustracion de examen"
            className="object-contain"
            style={{ width: `${imageSize}px`, height: `${imageSize}px` }}
          />
        </div>
      </div>

      <button
        type="button"
        onClick={onClick}
        className="ml-2 w-40 shrink-0 rounded-lg border border-indigo-700 bg-indigo-600 px-3 py-2 text-xs font-semibold text-white shadow-md transition hover:bg-indigo-700 focus:outline-none focus:ring-0 active:outline-none md:ml-0 md:mt-4 md:block md:w-full md:rounded-xl md:px-6 md:py-3 md:text-base"
      >
        Comenzar simulador
      </button>
    </div>
  );
}
